import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {RoutesAddonsEnums, RoutesEnums} from '../../enums/RoutesEnums';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    this.router.navigate(['/', RoutesEnums.RELATED, RoutesAddonsEnums.RELATED_CAREPROVIDER]);
    return false;
  }
}
